// Eligibility check card. Mirrors data-component="gift-eligibility".
//
// TODO(runtime): hydrate from
// dist/account-workflows.giftEligibility(state, customerId, now)
// (confirmed in dist/account-workflows.mjs). The returned shape is
// {eligible:boolean, reason:string, nextEligibleAt?:number}. The rules
// enforced server-side:
//   - service-gate preview must allow offer
//   - no pending/attached/unknown/held gift already
//   - 90 days since the last shipped gift (if any)
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';

export interface EligibilityCheck {
  label: string;
  passing: boolean;
}

export interface GiftEligibilityProps {
  checks: EligibilityCheck[];
}

export function GiftEligibility({ checks }: GiftEligibilityProps): ReactNode {
  return (
    <section className="card" data-component="gift-eligibility">
      <div className="section-heading">
        <h3>Eligibility check</h3>
      </div>
      <div className="gift-eligibility">
        {checks.map((check) => (
          <div key={check.label}>
            <Icon id="check" />
            <span>{check.label}</span>
          </div>
        ))}
        <p>Actual gift limits, intervals and approvals are supplied by the gift program.</p>
      </div>
    </section>
  );
}
